import { convertSecondsToHoursAndMinutes } from './helpers';
export function createWeatherCardTemplate(weatherInfo) {
  console.log(weatherInfo);

  return `<div class="weather-card">
        <h2 class="city-name">${weatherInfo.name}</h2>
        <ul class="weather-info list">
          <li class="weather-info-item">
            <p class="temp">
              Температура: ${weatherInfo.main.temp}<sup>&#176;</sup>
            </p>
          </li>
          <li class="weather-info-item">
            <p class="feels-like-temp">
              Відчувається як: ${weatherInfo.main.feels_like}<sup>&#176;</sup>
            </p>
          </li>
          <li class="weather-info-item">
            <p class="sunrise-time">Схід сонця: ${convertSecondsToHoursAndMinutes(weatherInfo.sys.sunrise)}</p>
          </li>
          <li class="weather-info-item">
            <p class="sunset-time">Захід сонця: ${convertSecondsToHoursAndMinutes(weatherInfo.sys.sunset)}</p>
          </li>
          <li class="weather-info-item">
            <p class="clouds">Хмарність: ${weatherInfo.clouds.all}%</p>
          </li>
        </ul>
      </div>
    `;
}
